<template>
  <b-modal
    id="modalTaskComments"
    ref="modalTaskComments"
    :no-enforce-focus="true"
    size="lg"
    @hidden="onHidden"
  >
    <div slot="modal-title">
      <i class="fas fa-comments mr-2" />
      {{ 'Comments' | translate }}
      <span v-if="task && (task.name || task.code)" class="text-muted ml-2">
        — {{ task.name || task.code }}
      </span>
    </div>

    <task-comment-section
      v-if="task && task.id"
      :task-id="task.id"
      :read-only="readOnly"
    />

    <div slot="modal-footer">
      <b-btn variant="default" @click="close">
        {{ 'Close' | translate }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import TaskCommentSection from '@/pages/task/task-comment/components/TaskCommentSection.vue'

export default {
  name: 'TaskCommentModal',
  components: {
    'task-comment-section': TaskCommentSection
  },
  props: {
    task: { type: Object, required: true },
    readOnly: { type: Boolean, default: false }
  },
  mounted () {
    this.$refs.modalTaskComments.show()
  },
  methods: {
    close () {
      this.$refs.modalTaskComments.hide()
    },
    onHidden () {
      this.$emit('close')
    }
  }
}
</script>
